import {FC, useContext, useEffect, useLayoutEffect} from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";
import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";

import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";
import { forgotpasswordSchema } from "../../validation/forgotPassword";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { ForgotPasswordResponseType } from "./types";
import { LoaderContext } from "../../context/loaderContext";
import  ZilrettaLogo  from "src/assets/images/zilrettaLogo.png";
import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";
import { Link } from "react-router-dom";
import IoveraLogo from "../../assets/images/iovera-logo.svg";

const HubForgotPassword: FC = (): JSX.Element => {
  const { control, handleSubmit, reset } = useForm({
    mode: 'all',
    resolver: yupResolver(forgotpasswordSchema),
  });
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);
  const { loading, error, data, mutate, removeErrorAndData } = useFetch<null, null, ForgotPasswordResponseType>(APIEndpoints.USER_FORGOT_PASSWORD);

  useEffect(() => {
    if (data || error) {
      hideLoader();
      if (data) {
        const { message } = data;
        showToast([message], ToastTypes.SUCCESS);
        reset();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const submitForm = async (values: { email: string }) => {
    setLoader();
    if ((error && error.length > 0) || data) removeErrorAndData();

    mutate({ user: values });
  };




  return (
      <div className="login-sec pt-3 d-flex flex-fill flex-column justify-content-between overflow-auto">
          <div className="container d-flex flex-fill">
              <div className="row flex-fill mt-lg-5">
                  <div className="col-lg-8 col-12">
                      <div className="products-logos flex-wrap gap-3 gap-lg-5 mb-3 mb-lg-0">
                          <img className="zilretta-logo" src={ZilrettaLogo} alt="ZilrettaLogo"/>
                          <img className="iovera-logo" src={IoveraLogo} alt="HeroImage"/>
                      </div>
                  </div>
                  <div className="col-lg-4 col-12">
                      <form className="login-box bg-white rounded-3 p-4 shadow-lg" onSubmit={handleSubmit(submitForm)}>
                          <h5 className="mb-0 fw-normal">Forgot your</h5>
                          <h3 className="mb-3 fw-medium">Password</h3>
                          <div>
                              <Controller
                                  name="email"
                                  control={control}
                                  defaultValue=""
                                  render={({field, fieldState: {error}}) => (
                                      <>
                                          <label htmlFor="email" className="form-label justify-content-start mb-2">Email
                                              *</label>
                                          <HubInputField
                                              inputId="email"
                                              isRowBased={false}
                                              isRequired={true}
                                              field={field}
                                              error={error}
                                              inputType="email"
                                          />
                                      </>
                                  )}
                              />
                          </div>
                          <div className="d-flex justify-content-between align-items-center gap-2 gap-lg-0">
                              <button disabled={loading} className="btn btn-primary" type="submit">
                                  {loading ? (<i className="spinner-border"></i>) : null}
                                  Send me reset password instruction
                              </button>
                              <p className="small mb-0 text-center" style={{minWidth:90}}>
                                  <Link to="/users/sign_in">Back to Log in</Link>
                              </p>
                          </div>
                      </form>
                  </div>
              </div>
          </div>
          <FooterText footerType="black"/>
      </div>
  );
};

export default HubForgotPassword;
